import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Star } from "lucide-react";

const PLAY_URL = "https://play.google.com/store/apps/details?id=com.sux1.app";
const KEY = "sux1_review_prompt";
const WEEK = 7 * 24 * 3600 * 1000;
const load = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; } };
const save = (s) => localStorage.setItem(KEY, JSON.stringify(s));

// Asks happy users for a Play Store review after their 3rd summary ("Plus tard" = 7 days, "Non merci" = never).
export function ReviewPrompt({ summaryId }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!summaryId) return;
    const s = load();
    if (s.last !== summaryId) { s.count = (s.count || 0) + 1; s.last = summaryId; save(s); }
    setShow(!s.done && s.count >= 3 && (!s.later || Date.now() > s.later));
  }, [summaryId]);
  if (!show) return null;
  const close = (patch) => { save({ ...load(), ...patch }); setShow(false); };
  const btn = "font-mono uppercase tracking-[0.14em] text-[11px] px-4 py-2 transition-colors";
  return (
    <div className="mt-8 max-w-3xl border-2 border-[#002FA7] bg-[#002FA7]/5 p-5" data-testid="review-prompt">
      <div className="flex items-start gap-3">
        <div className="flex shrink-0 text-[#F5B400]" aria-hidden="true">{[0, 1, 2, 3, 4].map((i) => <Star key={i} className="w-4 h-4 fill-current" />)}</div>
        <div className="min-w-0">
          <p className="font-bold">{t("review.title", "SUX1 vous aide ? Dites-le en 10 secondes !")}</p>
          <p className="text-sm text-muted-foreground mt-1">{t("review.body", "Un avis sur le Play Store aide d'autres élèves, parents et professeurs à découvrir SUX1. Merci !")}</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mt-4 justify-end">
        <button type="button" onClick={() => close({ done: true })} className={`${btn} text-muted-foreground hover:text-foreground`} data-testid="review-never-btn">{t("review.never", "Non merci")}</button>
        <button type="button" onClick={() => close({ later: Date.now() + WEEK })} className={`${btn} border border-[#002FA7] text-[#002FA7] hover:bg-[#002FA7] hover:text-white`} data-testid="review-later-btn">{t("review.later", "Plus tard")}</button>
        <a href={PLAY_URL} target="_blank" rel="noopener noreferrer" onClick={() => close({ done: true })} className={`${btn} bg-[#002FA7] text-white hover:bg-[#001f73] flex items-center gap-2`} data-testid="review-rate-btn">
          <Star className="w-3.5 h-3.5" /> {t("review.rate", "Laisser un avis")}
        </a>
      </div>
    </div>
  );
}

export default ReviewPrompt;
